import TERMS from 'constants/terms';

function Ctrl($scope, $rootScope, $state, $stateParams, authService, userService) {
  $scope.user = null;
  $scope.form = {};
  $scope.showSignup = true;
  $scope.showLogin = false;
  $scope.submitting = false;
  $scope.submitted = false;
  $scope.errorMsg = null;
  $scope.result = null;
  $scope.terms = TERMS;

  $scope.toggleLoginSignUp = function() {
    $scope.form = {};
    $scope.showLogin = !$scope.showLogin;
    $scope.showSignup = !$scope.showSignup;
    $scope.errorMsg = null;
    $scope.submitting = false;
    $scope.submitted = false;
    $scope.result = null;
  };

  $scope.signUp = function(form) {
    $scope.submitted = true;

    if (!form.$valid) return null;

    return authService.register($scope.form, function(response) {
      $scope.next(null, response.user);
    }, function(err) {
      $scope.next(err);
    });
  };

  $scope.login = function(form) {
    $scope.submitted = true;

    if (!form.$valid) return null;

    const email = $scope.form.email;
    const password = $scope.form.password;

    return authService.login(email, password, function(response) {
      $scope.result = 'success';

      $scope.alreadyAffiliate = response.user.promoter;

      if ($scope.alreadyAffiliate) return;

      $scope.next(null, response.user);
    }, function(err) {
      $scope.result = 'error';
      $scope.next(err);
    });
  };

  $scope.next = function(err, user) {
    $scope.submitting = false;
    $scope.submitted = false;

    if (err) {
      $scope.errorMsg = err.data.errors[0].message;
      return $scope.errorMsg;
    }

    if (!user) {
      $scope.errorMsg = 'Something went wrong...';
      return $scope.errorMsg;
    }

    $scope.user = user;
    $scope.form = {};
    $scope.result = null;

    return null;
  };

  $scope.becomeAffiliate = function(form) {
    $scope.submitted = true;

    if (!form.$valid) return null;

    if ($scope.form.name) {
      $scope.form.name = $scope.form.name.toLowerCase().trim().replace(/ /gi, '-');
    }

    const userId = $scope.user.id;

    return userService.markAffiliate(userId, $scope.form)
      .then(function() {
        $scope.result = 'success';

        $scope.submitting = false;

        $state.go('inactive');
      })
      .catch(function(err) {
        $scope.errorMsg = err.data.errors[0].message;

        $scope.result = 'error';

        $scope.submitting = false;

        $scope.errorMsg = err.data.errors[0].message;
      });
  };

  $scope.signUpButtonOptions = buttonOptions('Next');
  $scope.loginButtonOptions = buttonOptions('Next');
  $scope.affiliateButtonOptions = buttonOptions('Sign Up');

  function buttonOptions(title) {
    title = title || 'Next';
    return {
      buttonDefaultText: title,
      buttonSubmittingText: title,
      buttonSuccessText: 'Success',
      buttonErrorText: 'Error',
      buttonSubmittingIcon: 'icon-left fa fa-spin fa-refresh',
      buttonSuccessIcon: 'icon-left fa fa-check',
      buttonErrorIcon: 'icon-left fa fa-remove',
      buttonSuccessClass: 'btn-success',
      buttonErrorClass: 'btn-danger'
    };
  }
}

Ctrl.$inject = [
  '$scope',
  '$rootScope',
  '$state',
  '$stateParams',
  'tl.auth.service',
  'tl.user.service'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/signup/signupCtrl.js